import React from 'react';

const KittenTicker = ({ active, text, bgColor, textColor, fontSize, fontFamily, height }) => {
  if (!active || active !== 'true') return null;

  const bg = bgColor || '#B91C1C';
  const fg = textColor || '#FFFFFF';
  const size = fontSize || '14';
  const font = fontFamily || 'DM Sans';
  const h = height || '40';

  return (
    <div
      data-testid="kitten-ticker"
      className="w-full overflow-hidden cursor-pointer shadow-md flex items-center"
      style={{ backgroundColor: bg, color: fg, height: `${h}px`, fontFamily: font, fontSize: `${size}px` }}
    >
      <div className="animate-marquee whitespace-nowrap font-medium tracking-wide">
        <span className="mx-8">
          &#x1f43e; {text || 'Wir haben aktuell kleine Schneeblumen! Jetzt informieren & registrieren'} &#x1f43e;
        </span>
        <span className="mx-8">
          &#x1f43e; {text || 'Wir haben aktuell kleine Schneeblumen! Jetzt informieren & registrieren'} &#x1f43e;
        </span>
        <span className="mx-8">
          &#x1f43e; {text || 'Wir haben aktuell kleine Schneeblumen! Jetzt informieren & registrieren'} &#x1f43e;
        </span>
      </div>
    </div>
  );
};

export default KittenTicker;
